import React from "react";
import {
  QueryAttackModeData,
  SubscribeAttackModeData,
  SubscribeDriverAttackModeStateUpdate,
  SubscribeAttackLossUpdate,
} from "../../../utils/graphql/hooks/attackModeHooks";

export default function AttackModeDataManager() {
  QueryAttackModeData();
  SubscribeAttackModeData();
  SubscribeDriverAttackModeStateUpdate();
  SubscribeAttackLossUpdate();
  return <></>;
}
